/** Pagination des ressources partagées (config + panneau présentateur/modérateur), size 20. */
export const SHARED_RESOURCES_PAGE_SIZE = 20;

/**
 * Détermine la page à recharger après une suppression : si l'élément supprimé était le dernier de
 * la page courante (et qu'on n'est pas déjà sur la première page), on revient à la page précédente
 * plutôt que d'afficher une page vide alors qu'il reste des résultats avant.
 */
export const nextPageAfterDelete = (
  currentPage: number,
  itemsOnPageBeforeDelete: number,
): number => (itemsOnPageBeforeDelete <= 1 && currentPage > 0 ? currentPage - 1 : currentPage);
